import React, { useState } from 'react'
import { useProfilePrompt } from '../../useProfilePrompt'
import { RenderItemProps } from '../types'
import { BaseCard } from './BaseCard'
import { Calendar } from '@/components'
import { useAppI18N } from '@/app'

export const BirthdayCard = ({ item }: RenderItemProps) => {
  const prompt = useProfilePrompt(item)

  const { t } = useAppI18N()

  const [date, setDate] = useState(null)

  const onDateChange = (newDate) => {
    setDate(newDate)
    prompt.form.setFieldValue('birthday' as any, newDate)
  }

  return (
    <BaseCard prompt={prompt}>
      <Calendar
        // @ts-ignore
        value={date}
        onValueChange={onDateChange}
        placeholder={'01/07/2023'}
        // @ts-ignore
        leftIcon={{ name: 'calendar' }}
        label={t('AboutYou.calendarLabel')}
        variants={['prompt']}
        onVisibleChange={(to) => BaseCard.setOpenPortal(prompt, to)}
      />
    </BaseCard>
  )
}
